@if (analysisErrorState) {
  <div class=" flex h-full">
    <div class="text-center my-auto">
      @switch (analysisErrorState) {
        @case (ErrorAnalysis.noDataAvailable) {
          <div>
            <div class="text-2xl font-semibold text-gray-900">Keine Daten verfügbar</div>
            <div class="text-gray-500">Es ist ein Fehler beim Laden des Events aufgetreten.<br>Bitte versuchen Sie es in
              einigen Minuten erneut.<br>Wir bitten um Entschuldigung.
            </div>
          </div>
        }
        @case (ErrorAnalysis.noOrderRegistered) {
          <div>
            <div class="text-2xl font-semibold text-gray-900">Keine Bestellungen hinterlegt</div>
            <div class="text-gray-500">Es sind keine Verkäufe für den Zeitraums des Events registriert.</div>
          </div>
        }
        @case (ErrorAnalysis.startTimeInFuture) {
          <div>
            <div class="text-2xl font-semibold text-gray-900">Das Startdatum liegt in der Zukunft</div>
            <div class="text-gray-500">Bitte versuchen Sie es erneut, wenn das Event gestartet ist.</div>
          </div>
        }
        @case (ErrorAnalysis.noDate) {
          <div>
            <div class="text-2xl font-semibold text-gray-900">Fehlerhaftes Datum</div>
            <div class="text-gray-500">Bitte versuchen Sie es erneut.</div>
          </div>
        }
        @case (ErrorAnalysis.serverError) {
          <div>
            <div class="text-2xl font-semibold text-gray-900">Server Fehler</div>
            <div class="text-gray-500">Bitte versuchen Sie es in ein paar Minuten erneut.</div>
          </div>
        }
        @case (ErrorAnalysis.negativeValues) {
          <div>
            <div class="text-2xl font-semibold text-gray-900">Datensatz unpassend</div>
            <div class="text-gray-500">Bitte schließen Sie alle negativen Datensätze aus um das Chart einzusehen.</div>
          </div>
        }
        @case (ErrorAnalysis.invalidEventId) {
          <div>
            <div class="text-2xl font-semibold text-gray-900">Keine EventId angeben</div>
            <div class="text-gray-500">Bitte überprüfen Sie den eingegeben Link und laden Sie anschließend die Seite
              erneut.
            </div>
          </div>
        }
      }
    </div>
  </div>
}

